import { FC, PropsWithChildren } from 'react';
import { Flex } from '@servicetitan/anvil2';

interface ConfigurationWrapperProps extends PropsWithChildren {
    isLoaded?: boolean;
}

export const ConfigurationWrapper: FC<ConfigurationWrapperProps> = ({
    children,
    isLoaded = true,
}) => {
    if (!isLoaded) {
        return null;
    }

    return (
        <Flex direction="column" lg={{ direction: 'row' }} gap={8}>
            {children}
        </Flex>
    );
};
